module.exports = __webpack_public_path__ + "static/media/philip.a7a3cd26.jpg";